function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import { css } from '@emotion/react';
import { forwardRef } from 'react';
import { theme } from '@arc/frontend/ui-theme';
const styles = {
  radioButtonWrapper: process.env.NODE_ENV === "production" ? {
    name: "fxytqy",
    styles: "display:flex;max-width:100%"
  } : {
    name: "s3byjt-radioButtonWrapper",
    styles: "display:flex;max-width:100%;label:radioButtonWrapper;",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  },
  radioButton: /*#__PURE__*/css({
    minWidth: 18,
    height: 18,
    width: 18,
    marginTop: 1,
    '&:disabled': process.env.NODE_ENV === "production" ? {
      name: "1sfig4b",
      styles: "cursor:not-allowed"
    } : {
      name: "kfrixr---disabled",
      styles: "cursor:not-allowed;label:--disabled;",
      toString: _EMOTION_STRINGIFIED_CSS_ERROR__
    },
    '&[readonly]': process.env.NODE_ENV === "production" ? {
      name: "1ll9bqd",
      styles: "cursor:default"
    } : {
      name: "1x82fqn---readonly-",
      styles: "cursor:default;label:--readonly-;",
      toString: _EMOTION_STRINGIFIED_CSS_ERROR__
    },
    accentColor: theme.colors.palettes.primary.main
  }, process.env.NODE_ENV === "production" ? "" : ";label:radioButton;")
};
// eslint-disable-next-line @typescript-eslint/no-shadow
export const Radio = forwardRef(function Radio({
  className,
  containerStyle,
  children,
  ...props
}, ref) {
  return <div css={[styles.radioButtonWrapper, containerStyle, process.env.NODE_ENV === "production" ? "" : ";label:Radio;"]} className={className}>
			<input type="radio" ref={ref} css={styles.radioButton} {...props} />
			{children}
		</div>;
});